import momentTimezone from 'moment-timezone';
import moment from 'moment-timezone';

//convert UTC-> DST
export const convertDateFromUTC = (value) => {
    return momentTimezone.tz(momentTimezone.utc(value), momentTimezone.tz.guess())
}

//convert DST-> UTC
export const convertDateToUTC = (value) => {
    return momentTimezone.tz(value, momentTimezone.tz.guess()).utc()
}

export const getMomentFromOrginDate = (value) => {
    return moment(value);
}


// WEBPACK FOOTER //
// ./src/services/dst.js